import React from "react"

import "./footer.scss"

import { getSiteUrl } from "@repo/shared"
import classNames from "classnames"
import { useLocale, useTranslations } from "next-intl"

import { LogoH5 } from "./images/logo"

export interface FooterProps {
  className?: string
}

interface FooterLink {
  href: string
  label: string
}

// 社交媒体图标组件
const SocialMediaIcons: React.FC<{ className?: string }> = ({ className }) => {
  // 添加错误处理
  const t = useTranslations("footerComp")

  const socialMedia = [
    {
      name: t("socialMedia.0.name"),
      href: t("socialMedia.0.href"),
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Frame" opacity="0.8">
            <path
              id="Vector"
              d="M21.0465 15C21.0465 18.3394 18.3387 21.0465 15 21.0465C11.6606 21.0465 8.95349 18.3394 8.95349 15C8.95349 14.6025 8.99274 14.2137 9.06759 13.8372H5V21.8743C5 23.5995 6.39752 25 8.12572 25H21.8743C23.5995 25 25 23.601 25 21.8743V13.8372H20.9338C21.0073 14.2137 21.0465 14.6025 21.0465 15ZM21.8743 5H8.12572C6.39896 5 5 6.3997 5 8.12575V11.5116H10.0625C11.157 9.96513 12.96 8.95349 15 8.95349C17.04 8.95349 18.843 9.96513 19.9375 11.5116H25V8.12575C25 6.40045 23.6002 5 21.8743 5ZM23.4033 8.86048C23.4033 9.16862 23.1519 9.41862 22.8452 9.41862H21.1722C20.8655 9.41862 20.6141 9.16716 20.6141 8.86048V7.18606C20.6141 6.87792 20.8663 6.62791 21.1722 6.62791H22.8452C23.1533 6.62791 23.4033 6.87938 23.4033 7.18606V8.86048ZM18.7209 15C18.7209 12.944 17.0545 11.2791 15 11.2791C12.9455 11.2791 11.279 12.944 11.279 15C11.279 17.056 12.9455 18.7209 15 18.7209C17.0545 18.7209 18.7209 17.056 18.7209 15Z"
              fill="#EFF0F5"
            />
          </g>
        </svg>
      ),
    },
    {
      name: t("socialMedia.1.name"),
      href: t("socialMedia.1.href"),
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Frame" opacity="0.8">
            <path
              id="Vector"
              d="M20.7512 6H23.818L17.1179 13.6246L25 24H18.8284L13.9946 17.7074L8.46357 24H5.39494L12.5613 15.8446L5 6H11.3283L15.6976 11.7517L20.7512 6ZM19.6748 22.1723H21.3742L10.4049 7.7317H8.5813L19.6748 22.1723Z"
              fill="#EFF0F5"
            />
          </g>
        </svg>
      ),
    },
    {
      name: t("socialMedia.2.name"),
      href: t("socialMedia.2.href"),
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Frame 495" opacity="0.8">
            <g id="in 1" clipPath="url(#clip0_2748_16711)">
              <path
                id="Vector"
                d="M15 5C9.47773 5 5 9.47773 5 15C5 20.5223 9.47773 25 15 25C20.5223 25 25 20.5223 25 15C25 9.47773 20.5223 5 15 5ZM12.5559 19.1674H10.5273V12.6244H12.5559V19.1674ZM11.5268 11.8482C11.1825 11.899 10.832 11.8123 10.5512 11.6068C10.2703 11.4013 10.0816 11.0935 10.0258 10.75C9.97001 10.4065 10.0516 10.0548 10.253 9.77096C10.4544 9.48713 10.7594 9.29395 11.1021 9.23317C11.4448 9.17239 11.7976 9.24889 12.0843 9.44613C12.371 9.64337 12.5686 9.94552 12.6344 10.2873C12.7002 10.629 12.6288 10.9829 12.4358 11.2725C12.2427 11.5621 11.9435 11.764 11.6027 11.8348C11.576 11.8348 11.5514 11.8326 11.5246 11.8303L11.5268 11.8482ZM19.9447 19.1674H17.9152V15.5541C17.9152 14.7215 17.625 14.1635 16.8885 14.1635C16.6586 14.1663 16.4353 14.2403 16.2493 14.3755C16.0634 14.5106 15.924 14.7002 15.8504 14.918C15.817 15.0882 15.817 15.2633 15.8504 15.4336L15.8482 19.159H13.7656V12.625H15.5291L15.6268 13.5268C15.846 13.1943 16.1463 12.9231 16.4994 12.7388C16.8524 12.5545 17.2466 12.4631 17.6447 12.4732C19.0314 12.4732 19.975 13.3615 19.975 15.25C19.9732 15.25 19.9441 19.1674 19.9441 19.1674H19.9447Z"
                fill="#EFF0F5"
              />
            </g>
          </g>
          <defs>
            <clipPath id="clip0_2748_16711">
              <rect width="20" height="20" fill="white" transform="translate(5 5)" />
            </clipPath>
          </defs>
        </svg>
      ),
    },
    {
      name: t("socialMedia.3.name"),
      href: t("socialMedia.3.href"),
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Frame" opacity="0.8">
            <path
              id="Subtract"
              d="M23 5C24.1046 5 25 5.89543 25 7V23C25 24.1046 24.1046 25 23 25H19.1738V17H21.4072L21.7178 14.2295H19.1738V12.9863C19.1738 12.5908 19.2015 12.3075 19.3145 12.166C19.4558 11.9116 19.7391 11.7988 20.1914 11.7988H21.6895V9.02832H19.1738V9C18.6651 9 18.1844 9.05621 17.6191 9.28223C16.4602 9.76274 15.8946 10.8374 15.8945 12.5615V14.2295H14.2832V17H15.8945V25H7C5.89543 25 5 24.1046 5 23V7C5 5.89543 5.89543 5 7 5H23Z"
              fill="#EFF0F5"
            />
          </g>
        </svg>
      ),
    },
    {
      name: t("socialMedia.4.name"),
      href: t("socialMedia.4.href"),
      icon: (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g id="Frame 497" opacity="0.8">
            <g id="facebook 1">
              <path
                id="Subtract"
                d="M24 8C24.5523 8 25 8.44772 25 9V21C25 21.5523 24.5523 22 24 22H6C5.44772 22 5 21.5523 5 21V9C5 8.44772 5.44772 8 6 8H24ZM13.6338 18.3877L18.8486 15.377L13.6338 12.3662V18.3877Z"
                fill="#EFF0F5"
              />
            </g>
          </g>
        </svg>
      ),
    },
  ]

  return (
    <div className={classNames("smmFooterSocialMedia", className)}>
      {socialMedia.map((social, index) => (
        <a target="_blank" key={index} href={social.href} className="smmFooterSocialLink" aria-label={social.name}>
          {social.icon}
        </a>
      ))}
    </div>
  )
}

// 联系信息组件
const ContactInfo: React.FC<FooterProps> = ({ className }) => {
  const t = useTranslations("footerComp")

  return (
    <div className={classNames("smmFooterContactDetails", className)}>
      <div className="smmFooterContactItem">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
          />
        </svg>
        <a href={`mailto:${t("contactInfo.email")}`}>
          {t("contactInfo.emailLabel")} {t("contactInfo.email")}
        </a>
      </div>

      <a href={`tel:${t("contactInfo.phone").replace(/\s/g, "")}`} className="smmFooterContactItem">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"
          />
        </svg>
        <span>{t("contactInfo.phone")}</span>
      </a>

      <a
        href="https://api.whatsapp.com/send/?phone=8618521495560&text&type=phone_number&app_absent=0"
        target="_blank"
        className="smmFooterContactItem"
      >
        <svg fill="currentColor" viewBox="0 0 24 24">
          <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893A11.821 11.821 0 0020.885 3.488" />
        </svg>
        <span>{t("contactInfo.whatsapp")}</span>
      </a>
    </div>
  )
}

const IndexFooter: React.FC<FooterProps> = ({ className = "" }) => {
  const t = useTranslations("footerComp")
  const locale = useLocale()
  const links = (t.raw("links") || []) as FooterLink[]
  return (
    <footer className={classNames("smmFooter", className)}>
      <div className="smmFooterContainer">
        <div className="smmFooterInner">
          <div className="smmFooterInnerLeft" />
          <div className="smmFooterInnerRight" />
          <div className="smmFooterContent">
            {/* 标题和声明部分 */}
            <div className="smmFooterHeader">
              <LogoH5 width={80} height={28} className="smmFooterH5Logo" />
              <h2 className="smmFooterTitle">{t("title")}</h2>
              <ContactInfo className="smmFooterH5ContactInfo" />
              <SocialMediaIcons className="smmFooterH5SocialMedia" />
              <p className="smmFooterNotice">{t("notice")}</p>
            </div>

            {/* 导航链接部分 */}
            <div className="smmFooterNav">
              <nav className="smmFooterNavList">
                {links.map((link: FooterLink, index: number) => (
                  <React.Fragment key={index}>
                    <a href={getSiteUrl("www") + `/${locale}${link.href}`} target="_blank" className="smmFooterNavLink">
                      {link.label}
                    </a>
                    {index < links.length - 1 && <span className="smmFooterNavSeparator">|</span>}
                  </React.Fragment>
                ))}
              </nav>
            </div>

            {/* 联系信息和社交媒体部分 */}
            <div className="smmFooterContactSection">
              <div className="smmFooterContactInfo">
                {/* SMM Logo */}
                <div className="smmFooterLogo">
                  <LogoH5 width={80} height={32} />
                </div>
                {/* 联系信息 */}
                <ContactInfo />
              </div>

              {/* 社交媒体图标 */}
              <SocialMediaIcons />
            </div>

            {/* 版权信息 */}
            <div className="smmFooterCopyright">{t("copyright", { year: new Date().getFullYear() })}</div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default IndexFooter
